module.exports = __webpack_public_path__ + "media/images/one-de434c78.svg";